export const subMenuList = state => state.subMenuList

export const subMenuWidth = state => state.subMenuWidth

export const tabs = state => state.tabs

export const tabActiveName = state => state.tabActiveName

export const subMenuActiveName = state => state.subMenuActiveName

export const menuActiveName = state => state.menuActiveName

export const menuList = state => state.menuList

export const toggleMenuFromWhere = state => state.toggleMenuFromWhere

export const userInfo = state => state.userInfo

export const roles = state => state.roles

export const currentRoles = state => state.currentRoles
